import { Divider as AntDivider, type DividerProps as AntDividerProps } from 'antd'

interface DividerProps extends AntDividerProps {}

const Divider = ({ children, ...props }: DividerProps) => {
  return (
    <AntDivider
      styles={{
        root: { margin: 0 },
      }}
      {...props}
    >
      {children}
    </AntDivider>
  )
}

export default Divider
